import React, { useState } from "react";
import { Box, Paper, Tabs, Tab } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AppV2Integration from "../app_v2Integration/index";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    padding: 0,
    height: "calc(100vh - 122px)", // Match the header offset
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  tabContent: {
    flexGrow: 1,
    width: "100%",
    overflow: "hidden",
    position: "relative",
  },

}));

const CustomersSubscription = (props) => {
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div className={classes.root} style={{marginTop:'0px',height: "calc(111vh - 141px)"}}>
      <AppV2Integration user={props.user} path="/customers" height="100%" />
    </div>
  );
};

export default CustomersSubscription;
